module.exports = {"pathContext":{"name":"EncounterTemplateCategory","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CONSULT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DISCHARGE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"EXAM"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"SURGERY"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-encounter-template-category.json
// module id = 1242
// module chunks = 8516710538866